/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetTransactionMetricsOptions,
  GetTransactionMetricsResponses,
} from '../types/GetTransactionMetrics'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Excludes MIGRATION transactions. Served from an in-process cache refreshed every DORA_TRANSACTION_METRICS_REFRESH_INTERVAL (default 10s), so values may lag by up to one interval.
 * @summary Get total transaction counts and the count from the last 24 hours
 * {@link /v1/transactions/metrics}
 */
export function getTransactionMetrics<ThrowOnError extends boolean = true>(
  options: Options<GetTransactionMetricsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetTransactionMetricsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/transactions/metrics',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTransactionMetricsResponses, ThrowOnError>>,
  )
}
